import cookie from 'cookie';

const COOKIE_NAME = 'JGCookieNotice';
const COOKIE_ACCEPTED_VALUE = 'accept';
const COOKIE_EXPIRE_DAYS = 1000;

export function hasConsentCookie() {
  return cookie.parse(document.cookie)[COOKIE_NAME] === COOKIE_ACCEPTED_VALUE;
}

function getCookieDomain() {
  const hostname = document.location.hostname;
  const dotCom = '.justgiving.com';
  const dotService = '.justgiving.service';

  if (hostname.endsWith(dotCom)) return dotCom;
  if (hostname.endsWith(dotService)) return dotService;
  return null;
}

export function setConsentCookie() {
  const expires = new Date(Date.now() + COOKIE_EXPIRE_DAYS * 864e5);
  const domain = getCookieDomain();

  if (domain === null) return;

  document.cookie = cookie.serialize(COOKIE_NAME, COOKIE_ACCEPTED_VALUE, {
    expires,
    domain,
    path: '/',
  });
}
